import { Injectable } from '@angular/core';
import { HttpInterceptor } from '../common/services/httpInterceptor.service';
import { ConfigService } from '../common/services/config.service';
import { Observable } from 'rxjs/internal/Observable';
import { CommonConstants } from '../common/utilities/commonConstants';
import { CookieHandlerService } from '../common/services/cookieHandler.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
    providedIn: 'root'
})
export class VerifyOfficialEmailService {
    constructor(
        private _httpInterceptor: HttpInterceptor,
        private _http: HttpClient,
        private _cookieHandler: CookieHandlerService) { }

    public getOfficialEmailId(applicationId:any): Observable<any> {
        let url = format(ConfigService.getInstance().getConfigObject().APIURL.getOfficialMailId,applicationId);
        return this._httpInterceptor.Get(url);
    }
    public validateEmail(reqData: any, appId:string, token:any): Observable<any> {
        let url = format(ConfigService.getInstance().getConfigObject().APIURL.validateEmail,appId,token);
        return this._httpInterceptor.Put(url, reqData);
    }

    
}
